import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

const steps = [
  {
    n: "01",
    title: "We print a signed QR",
    desc: "Like a wax seal. Only we can make a real one.",
  },
  {
    n: "02",
    title: "We cut out the top-right corner",
    desc: "A normal camera can't read a broken code.",
  },
  {
    n: "03",
    title: "We drop a tiny QR in the hole",
    desc: "That's what your phone scans. It opens the right page.",
  },
  {
    n: "04",
    title: "A fake or a photocopy fails",
    desc: "It doesn't have the original signed code.",
  },
];

export default function TwinMatrix() {
  return (
    <div>
      <Nav />

      <section className="border-b border-black bg-[color:var(--cc-bg-2)]" data-testid="twin-matrix-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
          <div className="label-tag mb-4 inline-block bg-[color:var(--cc-yellow)] px-2 py-1">
            Asset stickers
          </div>
          <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
            Twin Matrix
          </h1>
          <p className="mt-3 font-display font-black text-xl sm:text-2xl tracking-tight max-w-2xl">
            Why this sticker can&apos;t be faked.
          </p>
          <p className="mt-6 text-lg text-neutral-700 max-w-2xl">
            Curb Pro and Curb Retailer stickers put two QR codes in one square.
            Your phone only reads the small one. The big one is the seal.
          </p>
        </div>
      </section>

      <section className="border-b border-black bg-white" data-testid="twin-matrix-steps">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 border-l border-t border-black">
            {steps.map((s) => (
              <div key={s.n} className="border-r border-b border-black p-6 md:p-8 bg-white">
                <div className="font-mono-cc text-sm text-neutral-500">{s.n}</div>
                <div className="font-display font-black text-xl mt-2">{s.title}</div>
                <p className="mt-3 text-neutral-700">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-black bg-white" data-testid="twin-matrix-player">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
          <div className="label-tag mb-4">Watch it happen · ~30 seconds</div>
          <iframe
            src="/media/twin-matrix/index.html"
            title="Twin Matrix animation"
            className="w-full aspect-video border-2 border-black bg-black"
            allow="autoplay"
            data-testid="twin-matrix-iframe"
          />
        </div>
      </section>

      <Footer />
    </div>
  );
}
